<router-outlet></router-outlet>
<ngx-spinner  bdColor="rgba(51,51,51,0.8)"
size="medium"
color="#fff"
type="ball-elastic-dots" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>